import React from 'react';
import loaderSvg from '../resources/images/loader.svg';

export const Loader = () => (
  <div className="loading text-center">
    <img src={loaderSvg} alt="loading" />
  </div>
);
